"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormattedValue = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const defaultFormatOptions = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
};
const FormattedValue = exports.FormattedValue = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    value,
    postfix,
    className,
    formatOptions = defaultFormatOptions
  } = _ref;
  const formattedValue = (value !== null && value !== void 0 ? value : 0).toLocaleString("no-NO", formatOptions);
  return /*#__PURE__*/_react.default.createElement("span", {
    className: className,
    ref: ref
  }, formattedValue, postfix ? " ".concat(postfix) : "");
});